import ResultsWinsIconMain from '../Icons/ResultsWinsIconMain';
import React from 'react';
import ResultsScoreIcon from '../Icons/ResultsScoreIcon';
import UserProfileIcon from '../Icons/UserProfileIcon';

interface IResultsTotalCount {
  data: any;
  variant: 'wins' | 'score' | 'entries';
}
export default function ResultsTotalCount({
  data,
  variant,
}: IResultsTotalCount) {
  function numberWithCommas(x: number) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return (
    <div
      className={
        'bg-grayLight max-tablet:p-3 py-2 px-3 rounded-8 flex items-center justify-center gap-2 max-tablet:[&_svg]:w-8'
      }
    >
      {variant === 'wins' && <ResultsWinsIconMain />}
      {variant === 'score' && <ResultsScoreIcon />}
      {variant === 'entries' && <UserProfileIcon />}
      <div
        className={
          'flex items-center gap-1 text-primary text-16 tablet:text-18'
        }
      >
        <span>
          {variant === 'wins' && 'Wins:'}
          {variant === 'score' && 'Score:'}
          {variant === 'entries' && 'Entries:'}
        </span>
        <span className={'font-semibold'}>
          {variant === 'wins' &&
            numberWithCommas(
              data.reduce((s: number, a: { wins: number }) => s + a.wins, 0)
            )}
          {variant === 'score' &&
            numberWithCommas(
              data.reduce(
                (s: number, a: { aggregatedPlaces: number }) =>
                  s + a.aggregatedPlaces,
                0
              )
            )}
          {variant === 'entries' &&
            numberWithCommas(
              data.length
            )}
        </span>
      </div>
    </div>
  );
}
